import { MatchEnvironment } from "../../../modules/environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../modules/environment/envTypes"
import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { ComingSoonPlaceholder } from "./ComingSoonPlaceholder"

type EnvironmentBasedComponentProps = Readonly<{
    Component: React.ComponentType
}>

export function EnvironmentBasedComponent({ Component }: EnvironmentBasedComponentProps) {
    return (
        <>
            <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}>
                <Component />
            </MatchEnvironment>
            <MatchEnvironment environments={[EnvironmentType.Prod]}>
                <LocalizedStrict id="planning-tabs-placeholder" attrs={{ title: true, body: true }}>
                    <ComingSoonPlaceholder title="Coming soon" body="We are working to bring you this feature." />
                </LocalizedStrict>
            </MatchEnvironment>
        </>
    )
}
